import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-purple-700)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M17 9.33333C17 10.338 16.7135 11.2778 16.2154 12.0801L11.5 20L6.78417 12.0795C6.28633 11.2773 6 10.3378 6 9.33333C6 6.38781 8.46243 4 11.5 4C14.5376 4 17 6.38781 17 9.33333ZM11.5 11.1111C12.5125 11.1111 13.3333 10.3152 13.3333 9.33332C13.3333 8.35148 12.5125 7.55555 11.5 7.55555C10.4875 7.55555 9.66664 8.35148 9.66664 9.33332C9.66664 10.3152 10.4875 11.1111 11.5 11.1111Z"
    fill={textColor}
  />
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M22.48 12.24C22.48 13.4155 22.155 14.5151 21.5899 15.4537L16.24 24.72L10.8897 15.453C10.3249 14.5145 10 13.4152 10 12.24C10 8.79374 12.7937 6 16.24 6C19.6862 6 22.48 8.79374 22.48 12.24ZM16.24 14.32C17.3887 14.32 18.32 13.3887 18.32 12.24C18.32 11.0912 17.3887 10.16 16.24 10.16C15.0912 10.16 14.16 11.0912 14.16 12.24C14.16 13.3887 15.0912 14.32 16.24 14.32Z"
    fill={textColor}
  />
);

export const PinOnImageIcon = createSlideIcon(Icon24x24, Icon32x32);
